var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-wrapper"},[_c('div',{staticClass:"logo-bg mt16"},[_c('img',{attrs:{"src":_vm.logo,"width":"28","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }